export const logout = () => {
  localStorage.removeItem("token");
  window.location.href = "/admin";
};

export const isAuthenticated = () => {
  return !!localStorage.getItem("token");
};
